import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ruta_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && !err.config?.url?.includes("/auth/")) {
      localStorage.removeItem("ruta_token");
      localStorage.removeItem("ruta_user");
      if (window.location.pathname !== "/login" && window.location.pathname !== "/registro") {
        window.location.assign("/login");
      }
    }
    return Promise.reject(err);
  }
);
